import React, { createContext, useCallback, useContext, useEffect } from 'react'
import { RegistrationContextValue, RegistrationProviderProps } from '../types'
import { processToken } from '../../../lib/utils/api'

export const RegistrationContext = createContext<RegistrationContextValue>({
  // values
  isAuthenticated: false,
  route: '/',
  blok: null,
  params: undefined,

  // actions
  goto: () => { },
  setIsAuthenticated: () => null,
})

export const useRegistrationContext = () => useContext(RegistrationContext)
export const useParams = <T extends any>() => useRegistrationContext().params as T

export const RegistrationProvider = ({ children, blok }: RegistrationProviderProps) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState<RegistrationContextValue['isAuthenticated']>(null)
  const [route, setRoute] = React.useState<RegistrationContextValue['route']>('/')
  const [params, setParams] = React.useState<any>(undefined)

  const goto = useCallback((route: RegistrationContextValue['route'], params: any = undefined) => {
    setRoute(route)
    setParams(params)
  }, [])

  useEffect(() => {
    const token = localStorage.getItem('token')

    let isAuthenticated = false

    if (token) {
      let decodedToken = processToken(token)
      const { isExpired, data } = decodedToken

      if (!isExpired) {
        isAuthenticated = true
      }
    }
    setIsAuthenticated(isAuthenticated)
  }, [])

  const contextValue: RegistrationContextValue = {
    // values
    isAuthenticated,
    route,
    blok,
    params,

    // actions
    goto,
    setIsAuthenticated,
  }

  return <RegistrationContext.Provider value={contextValue}>{children}</RegistrationContext.Provider>
}
